export const SET_ROTA = "SET_ROTA";

export const setRota = (rota) => {
  return {
    type: SET_ROTA,
    payload: rota,
  };
};
